import * as React from 'react';

import { Messages } from '../../codegen/Localize';
import { PageHeaderButtonClickEvent, TelemetryEvents } from '../../common/telemetryEvents/TelemetryEvents';
import { IViewDetailInfo } from '../../ts/models/IViewInfo';
import { ConnectedBreadcrumbs } from '../content/breadcrumbs/ConnectedBreadcrumbs';
import { PreviousUrlInitialState } from '../reducers/PreviousUrlReducer';
import { ServerUrls } from '../ServerUrls';
import { isDatasourceOwnerPanelSubSpace } from '../state/SpaceInfo';
import { BackButton } from './BackButton';
import { ConnectedPageHeaderMenus } from './ConnectedPageHeaderMenus';
import { LeftItem, PageHeaderProps, Region, RightItem } from './PageHeader';
import { PageHeaderSearch, VizViewerSearchButton } from './PageHeaderSearch';
import { PageHeaderStyles } from './PageHeaderStyles';
import { VizViewerFavoriteButton, VizViewerPageHeaderButtons } from './VizViewerPageHeaderButtons';

interface VizViewerPageHeaderState {
  isSearchOpen: boolean;
}

export class VizViewerPageHeader extends React.PureComponent<PageHeaderProps, VizViewerPageHeaderState> {
  constructor(props: PageHeaderProps) {
    super(props);
    this.state = {isSearchOpen: false};
  }

  public render() {
    const parentWorkbookId = this.getParentWorkbookId();

    return (
      <div className={PageHeaderStyles.ContainerVizViewer}>
        <span className={PageHeaderStyles.LeftRegionVizViewer} >
          <Region>
            {this.backButton(parentWorkbookId)}
            {this.props.displayBreadCrumbs && <LeftItem><ConnectedBreadcrumbs /></LeftItem>}
            {this.shouldShowVizViewerFavoriteButton() && <VizViewerFavoriteButton {...this.props} />}
          </Region>
        </span>

        <span className={PageHeaderStyles.RightRegionVizViewer} >
        <Region>
          {this.vizViewerPageHeaderButtons()}
          <ConnectedPageHeaderMenus telemetryService={this.props.telemetryService} buttonType="light" showFavoritesMenu={this.shouldShowVizViewerFavoriteButton()} />
        </Region>
        </span>
      </div>
    );
  }

  private shouldShowVizViewerFavoriteButton = (): boolean => {
    return !isDatasourceOwnerPanelSubSpace(this.props.spaceInfo) && !this.props.isOnServerStatusViz && !this.props.isOnSiteStatusViz;
  }

  private vizViewerSearchButton = (): JSX.Element => {
    return (
      <RightItem>
        {VizViewerSearchButton({
          isSearchOpen: this.state.isSearchOpen,
          onClick: this.toggleSearchVisibility,
          title: this.state.isSearchOpen ? Messages.searchClose() : Messages.searchOpen(),
          testId: this.state.isSearchOpen ?'viz-header-search-open' :  'viz-header-search-close'
        })}
      </RightItem>
    );
  }

  private vizViewerPageHeaderButtons = (): JSX.Element => {
    if (this.state.isSearchOpen) {
      return (
        <>
          <RightItem>{PageHeaderSearch({angularContext: this.props.angularContext, searchClosed: this.onSearchClosed})}</RightItem>
          {this.vizViewerSearchButton()}
        </>
      );
    } else {
      const {isInVizViewerArea, addContentFavorite, removeContentFavorite, ...vizViewerButtonsProps} = this.props;
      return (
        <>
          <VizViewerPageHeaderButtons {...vizViewerButtonsProps} />
          <div className={PageHeaderStyles.VizViewerDivider} />
          {this.vizViewerSearchButton()}
        </>
      );
    }
  }

  private toggleSearchVisibility = () => {

    this.props.telemetryService.sendEvent<PageHeaderButtonClickEvent>({
      type: TelemetryEvents.PageHeaderButtonClick,
      button: 'viz-viewer-search',
      action: this.state.isSearchOpen ? 'close' : 'open'
    });

    this.setState((prevState) => {
      return {isSearchOpen: !prevState.isSearchOpen};
    },
    () => {
      // Might not need to use setTimeout when fully ported to React
      setTimeout(() => {
        if (this.state.isSearchOpen) {
          $('input[name="omniboxTextBox"]').focus();
        } else {
          $('input[name="omniboxTextBox"]').trigger('blur');
        }
      }, 50); // little extra time because angular is slow
    });
  }

  // Borrowed from TopBar.ts
  // We have to use this jquery code here because omniBox is in angular
  // so we can't use react refs here.
  private onSearchClosed = (event: BaseJQueryEventObject) => {
    const target = event && $(event.target);
    if (!target || (
          target.closest('.tb-search-box-icon-button').length === 0 &&
          target.closest('.tb-omnibox-popup').length === 0)
        ) {
      $('input[name="omniboxTextBox"]').trigger('blur');
      if (this.state.isSearchOpen) {
        this.setState({isSearchOpen: false});
      }
    }
  }

  private getParentWorkbookId() {
    const viewInfo: IViewDetailInfo = this.props.spaceInfo.item as IViewDetailInfo;
    const parentWorkbookId = viewInfo && viewInfo.workbook && viewInfo.workbook.id;
    return parentWorkbookId;
  }

  private backButton = (parentWorkbookId: string): JSX.Element => {
    if (!this.shouldShowBackButton(parentWorkbookId)) {
      return null;
    }

    return (
      <BackButton previousUrl={this.props.previousUrl}
        workbookId={parentWorkbookId}
        siteUrls={this.props.siteUrls}
        serverUrls={ServerUrls.getInstance()}
        isOnSiteStatusViz={this.props.isOnSiteStatusViz}
        isOnServerStatusViz={this.props.isOnServerStatusViz}
        telemetryService={this.props.telemetryService}
        buttonType={'light'}
        />);
  }

  private shouldShowBackButton = (parentWorkbookId: string) : boolean => {
    return !!parentWorkbookId
      || (this.props.previousUrl !== PreviousUrlInitialState)
      || this.props.isOnServerStatusViz
      || this.props.isOnSiteStatusViz;
  }
}
